import * as Sentry from "@sentry/vue";

export const LoadSentry = {
    install(app, options) {
        if (import.meta.env.PROD && !import.meta.env.SSR) {
            Sentry.init({
                app,
                dsn: "https://f5ad1abfd8ae103e89edd2ce5dcb53ed@o4507170379726848.ingest.de.sentry.io/4508733701750864",
                integrations: [
                    Sentry.replayIntegration(),
                ],
                // Tracing
                tracesSampleRate: 1.0, //  Capture 100% of the transactions
                tracePropagationTargets: [], // Disable trace header propagation
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        }
    },
};
